import { IMarketoField } from 'marketing-site/lib/marketo/@types/fields'
import { IFormField } from 'marketing-site/src/library/elements/Form/@types/FormField'
import { MarketoFieldTransformError } from './transformError'
import transformField from './transformField'
import { captureException } from 'marketing-site/lib/sentry'

/**
 * @param forceBusinessEmail Only applies to email fields
 * @param hideLabels Only applies to text, textArea and email
 * @param hiddenFieldIds Fields with these ids are converted to hidden, except if they are also required
 */
export default function transformMarketoFields(
  fields: IMarketoField[],
  forceBusinessEmail?: boolean,
  hideLabels?: boolean,
  hiddenFieldIds?: string[],
): IFormField[] {
  const transformedFields: IFormField[] = fields
    .map((field) => {
      try {
        return transformField({
          field,
          forceBusinessEmail: !!forceBusinessEmail,
          hideLabel: !!hideLabels,
          overrideHidden: !!hiddenFieldIds && hiddenFieldIds.includes(field.id) && !field.required,
        })
      } catch (error) {
        if (error instanceof MarketoFieldTransformError) {
          captureException(error.message)
        }
      }
    })
    .filter((field) => !!field) as IFormField[]
  return transformedFields
}
